<div class="box-paperless last roboto-r text-center">
  <div class="basicrow roboto-b f-bmed">
    <img class="nfact-e" width="100%" src="../../assets/images/fact-dig.png"> Factura Electr&oacute;nica
  </div>

  <div class="basicrow m-top m-bot-paper">
    <div>
      <div class="f-reg f-reg pull-left"  style="width: 50%;">
        <span class="roboto-b">Factura de Servicio</span><br/>
        Paperless
      </div>
      <div [hidden]="paperless!=true" class="pad-zero pull-left" style="width: 50%;">
        <div class="autocont f-green-i txtSusc1">
          <span class="f-newfdig">Suscrito a Factura Electr&oacute;nica</span>
        </div>
        <div class="autocont nofloat pad-left paper-green-size txtSusc2">
          <img class="fdig-check" width="44px" src="../../assets/images/fact-dig-check.png">
        </div>
      </div>
      <div class="col-xs-12  left-p" [hidden]="paperless==true">
        <label class="switch dig-def-i pull-left">
          <input type="checkbox" id="checkboxPeperless">
          <span class="slider" (click)="updatepaperless()">SI</span>
        </label>
      </div>
    </div>
  </div>

  <div class="basicrow m-top-u mob-m-top" style="margin: 10px 0;">
    <div class="logline full"></div>
  </div>

  <div class="basicrow roboto-b m-top-u">
    Correo electr&oacute;nico donde recibe las facturas:
  </div>

  <div class="basicrow">
   <div class="m-top-u updateEmail1">
      <input class="inp-f mailchngdef" placeholder="{{this.email}}" [(ngModel)]="this.newEmail">
      <a class="mailchng-btn vcenter cursor" [ngClass]="{'off': this.newEmail==''}" (click)="this.updateEmail()">
          <span class="tabcell">
              <i class="fa fa-pencil" aria-hidden="true"></i>
          </span>
      </a>
    </div>
  </div>
</div>